import { Stack, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import styles from "./Answer.module.css";

interface Props {
    error: string;
    onRetry: () => void;
}

export const AnswerError = ({ error, onRetry }: Props) => {
    return (
        <Stack className={styles.answerContainer} direction="column" justifyContent="space-between">
            <ErrorOutlineIcon aria-hidden="true" aria-label="Error icon" sx={{ color: "red" }} />

            <Stack flexGrow={1}>
                <p className={styles.answerText}>{error}</p>
            </Stack>

            <Button className={styles.retryButton} onClick={onRetry} variant="contained">Retry</Button>
        </Stack>
    );
};
